import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import CircleImage from '../components/CircleImage';
import * as settings from '../settings';

export default function AgentsPage({ isMobile }) {
  const agents = [
    {
      name: 'Matthew Kontos',
      title: 'Owner & Managing Broker',
      license: 'License #471.021736',
      image: 'https://ap.rdcpix.com/1490187338/098e89735970dd6f0ef8f17401c4c305a-e0rd-w260_h260.webp',
      description:
        'As the Owner and Managing Broker of Pembre Realty, I take pride in helping clients make confident real estate decisions. With over eight years of experience, I’ve learned that success in this business comes down to trust, communication, and follow-through. Whether you’re buying your first home or selling an investment property, my goal is to make the process as smooth and stress-free as possible.',
    },
    {
      name: 'Aneta Zaremba',
      title: 'Real Estate Broker',
      license: 'License #	475.215223',
      image: '/pembre-circle.png',
      description:
        'Real estate is more than transactions to me - it’s about people and their goals. I work closely with each client to understand what matters most and tailor my approach to fit their needs. From first-time buyers to seasoned investors, I strive to provide honest guidance, strong negotiation, and a positive experience every time.',
    },
    {
      name: 'Renee Kontos',
      title: 'Real Estate Broker',
      license: 'License #475.215216',
      image: '/pembre-circle.png',
      description:
        'I believe in building relationships that last well beyond the closing table. My clients know me for my attention to detail, responsiveness, and dedication to achieving their real estate goals. Every property and every client is unique, and I take pride in delivering personalized service that makes each experience exceptional.',
    },
  ];

  return (
    <>
      {/* Hero Section */}
      <div
        className="text-light d-flex align-items-center"
        style={{
          minHeight: '60vh',
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${settings.SITEURL}/hero-bg.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Container className="text-center">
          <h1 className="display-3 fw-bold mb-3">Meet Our Agents</h1>
          <p className="lead fs-3">
            Experienced. Dedicated. Local.
          </p>
          <p className="fs-5 mx-auto" style={{ maxWidth: '700px' }}>
            Our team of licensed professionals is committed to providing you with the highest level of service and expertise.
          </p>
        </Container>
      </div>

      {/* Agents Grid */}
      <div className="bg-light py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="fw-bold">The Pembre Team</h2>
            <p className="text-muted">Here to serve your real estate needs</p>
          </div>

          <Row xs={1} sm={2} md={3} className="g-4 justify-content-center">
            {agents.map((agent, index) => (
              <Col
                key={index}
                className="d-flex justify-content-center"
                style={{ maxWidth: '350px' }}
              >
                <Card className="text-center shadow-sm border-0 p-3 h-100 rounded-4 w-100 card-hover">
                  <div className="d-flex justify-content-center mt-3 mb-4">
                    <CircleImage src={agent.image} alt={agent.name} size={130} />
                  </div>
                  <Card.Body className="d-flex flex-column">
                    <Card.Title className="fw-bold fs-4">{agent.name}</Card.Title>
                    <Card.Subtitle className="mb-2 text-primary fw-semibold">
                      {agent.title}
                    </Card.Subtitle>
                    <div className="text-muted small mb-3">
                      {agent.license}
                    </div>
                    <Card.Text className="text-secondary mt-auto text-start small">
                      {agent.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* Our Values Section */}
      <div className="py-5 bg-white">
        <Container className="py-4">
          <div className="text-center mb-5">
            <h2 className="fw-bold">Our Core Values</h2>
            <p className="text-muted">What drives us every day</p>
          </div>
          <Row className="g-4 text-center">
            <Col md={4}>
              <div className="p-4 h-100 rounded-3 bg-light">
                <h3 className="h4 fw-bold mb-3">Integrity</h3>
                <p className="text-secondary">
                  We believe in doing the right thing, always. Transparency and honesty are at the heart of every interaction we have with our clients.
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="p-4 h-100 rounded-3 bg-light">
                <h3 className="h4 fw-bold mb-3">Expertise</h3>
                <p className="text-secondary">
                  Our agents are deeply knowledgeable about the local market. We leverage data and experience to guide you to the best decisions.
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="p-4 h-100 rounded-3 bg-light">
                <h3 className="h4 fw-bold mb-3">Client Focus</h3>
                <p className="text-secondary">
                  Your goals are our priority. We listen, adapt, and work tirelessly to ensure your real estate journey is successful and stress-free.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Join Our Team / CTA */}
      <div className="py-5 bg-primary text-white">
        <Container className="text-center py-4">
          <h2 className="fw-bold mb-3">Interested in Joining Pembre Realty?</h2>
          <p className="fs-5 mb-4" style={{ opacity: 0.9 }}>
            We're always looking for talented agents who share our passion for excellence.
          </p>
          <Button
            variant="light"
            size="lg"
            className="fw-bold px-5 rounded-pill shadow-sm text-primary"
            href="mailto:contact@pembre.com"
          >
            Get in Touch
          </Button>
        </Container>
      </div>
    </>
  );
}